'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const UnlinkedIcon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="currentColor" strokeWidth={2} strokeLinecap="round"><path d="M9 17A5 5 0 019 7M15 7a5 5 0 010 10" /></g></svg>);